import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="text-[10px] uppercase tracking-[0.28em] text-black/45 link-underline">
          ← Back to journal
        </Link>
        <h1 className="mt-6 font-serif text-5xl font-light tracking-tighter">Sign in</h1>
        <p className="mt-2 text-sm text-black/55">For the author. Private door.</p>

        <form onSubmit={onSubmit} className="mt-10 space-y-6" data-testid="login-form">
          <div>
            <label className="text-[10px] uppercase tracking-[0.28em] text-black/55">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-transparent border-b border-black/20 py-3 focus:outline-none focus:border-black"
              required
              data-testid="login-email-input"
            />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.28em] text-black/55">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-transparent border-b border-black/20 py-3 focus:outline-none focus:border-black"
              required
              data-testid="login-password-input"
            />
          </div>
          {error && (
            <div className="text-sm text-red-700" data-testid="login-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-black text-white py-4 text-[11px] uppercase tracking-[0.28em] hover:bg-black/85 transition-colors disabled:opacity-50"
            data-testid="login-submit-btn"
          >
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
